// extracted by mini-css-extract-plugin
module.exports = {"paywall-banners-container":"banner_paywall-banners-container___Whw7","banner-wrapper":"banner_banner-wrapper__Je37b","banner-name":"banner_banner-name__3dkku"};